import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { map, ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { list_type, string_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { equals, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { File_FileListItem, File_FileListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1, Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Msg, Model } from "./Types.fs.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { toggle } from "../../../../Bfs.Web.Portale/Helpers.fs.js";

export function Http_getKategorien() {
    const response = fetch("/api/file/kategorien", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(string_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getFiles(page, filter) {
    let arg_3;
    const response = fetch((filter.tag === 1) ? toText(printf("/api/file?page=%i&onlyNew=true"))(page) : ((filter.tag === 2) ? ((arg_3 = encodeURIComponent(filter.fields[0]), toText(printf("/api/file?page=%i&kategorie=%s"))(page)(arg_3))) : toText(printf("/api/file?page=%i"))(page)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(File_FileListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_downloadUrlById(id) {
    return toText(printf("/api/file/%O"))(id);
}

export function Http_downloadUrl(f) {
    return Http_downloadUrlById(f.Id);
}

export function Http_downloadMetadataUrl(f) {
    return toText(printf("/api/file/%O/metadata"))(f.Id);
}

export function State_init(page, user, lastModel) {
    const page_1 = page.fields[0] | 0;
    const filter = page.fields[1];
    let kategorienModel;
    if (lastModel == null) {
        kategorienModel = (new Remote$1(1, []));
    }
    else {
        const matchValue = lastModel.Kategorien;
        kategorienModel = ((matchValue.tag === 3) ? (new Remote$1(3, [matchValue.fields[0]])) : (new Remote$1(1, [])));
    }
    return [new Model(page_1, filter, kategorienModel, new Remote$1(1, []), empty()), Cmd_batch(ofArray([equals(kategorienModel, new Remote$1(1, [])) ? singleton((dispatch) => {
        dispatch(new Msg(2, []));
    }) : Cmd_none(), singleton((dispatch_1) => {
        dispatch_1(new Msg(0, [page_1, filter]));
    })]))];
}

function State_markFileRead(id, files) {
    return new Paginated$1(files.Page, files.PageSize, files.PageCount, map((i) => {
        if ((i.Id === id) && i.IsNew) {
            return new File_FileListItem(i.Id, i.Datum, i.Titel, i.Beschreibung, i.Filename, i.Kategorie, i.HasMetadata, i.Type, false);
        }
        else {
            return i;
        }
    }, files.Items));
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            return [new Model(model.PageNumber, msg.fields[0], model.Kategorien, Loaded(msg.fields[1]), model.ExpandedBeschreibungen), Cmd_none()];
        case 2:
            return [new Model(model.PageNumber, model.SelectedFilter, new Remote$1(1, []), model.Files, model.ExpandedBeschreibungen), request(Http_getKategorien, undefined, (Item) => (new Msg(3, [Item])))];
        case 3:
            return [new Model(model.PageNumber, model.SelectedFilter, Loaded(msg.fields[0]), model.Files, model.ExpandedBeschreibungen), Cmd_none()];
        case 4:
            return [new Model(model.PageNumber, model.SelectedFilter, model.Kategorien, model.Files, toggle(msg.fields[0], model.ExpandedBeschreibungen)), Cmd_none()];
        case 5: {
            const matchValue = model.Files;
            if (matchValue.tag === 3) {
                return [new Model(model.PageNumber, model.SelectedFilter, model.Kategorien, new Remote$1(3, [State_markFileRead(msg.fields[0], matchValue.fields[0])]), model.ExpandedBeschreibungen), Cmd_none()];
            }
            else {
                return [model, Cmd_none()];
            }
        }
        case 6:
            return [model, Cmd_none()];
        default: {
            const filter = msg.fields[1];
            return [new Model(model.PageNumber, model.SelectedFilter, model.Kategorien, new Remote$1(1, []), model.ExpandedBeschreibungen), request((tupledArg) => Http_getFiles(tupledArg[0], tupledArg[1]), [msg.fields[0], filter], (result) => (new Msg(1, [filter, result])))];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
